import { useMemo, useState, useEffect } from 'react';
import { Box, Grid2 } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import SkillBoxProductCard from '../../shared/components/SkillBoxProductCard';
import CustomDivider from '../../shared/utils/CustomDivider';
import HorizontalScroll from '../../shared/components/HorizontalScroll';
import { NavigateButton } from '../../shared/utils/CustomButton';
import { SkeletonCom } from '../../shared/utils/SkeletonCom';
import { useSkillBoxProducts, useSkillProductCategory } from '../../assets/api/useGetApi';

const SkillBoxScroller = () => {
    const navigate = useNavigate();
    const [selectedCategoryId, setSelectedCategoryId] = useState("");

    const { data: categoryData, isLoading: isCategoryLoading } = useSkillProductCategory();
    const categories = useMemo(() => categoryData?.data?.length > 0 ? categoryData.data : [], [categoryData?.data]);

    useEffect(() => {
        if (categories.length > 0 && !selectedCategoryId) {
            setSelectedCategoryId(categories[0].id);
        }
    }, [categories, selectedCategoryId]);

    const { data: skillBoxData, isLoading: isProductsLoading } = useSkillBoxProducts(selectedCategoryId, 1);
    const isLoading = isCategoryLoading || isProductsLoading;

    const sourceData = skillBoxData?.data?.length > 0 ? skillBoxData.data : [];

    const skillBoxProducts = useMemo(() => {
        return sourceData.map((p) => ({
            ...p,
            course_name: p.course_name || p.title,
            image_small: p.image_small || p.image,
        }));
    }, [sourceData]);

    return (
        <Box>
            <HorizontalScroll heading="Latest Products at Skill Box!" subheading="Our Learning Resources" size={3}>
                {!isLoading && (
                    skillBoxProducts?.slice(0, 6)?.map((item, index) => (
                        <Grid2 children key={item.id || index} size={{ xs: 12, sm: 5.7, lg: 3.7 }} sx={{ flex: "0 0 auto", display: "flex", alignItems: "stretch" }}>
                            <SkillBoxProductCard item={item} sourcePath="/" sourceName="Home" />
                        </Grid2>
                    ))
                )}
                {isLoading && (
                    [...Array(6)].map((_, index) => (
                        <Grid2 children key={index} size={{ xs: 12, sm: 5.7, lg: 3.7 }} sx={{ flex: "0 0 auto" }}>
                            <SkeletonCom />
                        </Grid2>
                    ))
                )}
            </HorizontalScroll>

            <CustomDivider orientation='horizontal' size={"30px"} />

            <NavigateButton onClick={() => navigate('/SkillBox')} />
        </Box>
    );
};

export default SkillBoxScroller;
